export const SINGAPORE_TIME_ZONE = 'Asia/Singapore';

export function slugify(value) {
  return value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[’']/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 55);
}

export function randomToken() {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export function randomShortCode() {
  const alphabet = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
  const bytes = new Uint8Array(6);
  crypto.getRandomValues(bytes);
  const raw = Array.from(bytes, (byte) => alphabet[byte % alphabet.length]).join('');
  return `${raw.slice(0, 4)}-${raw.slice(4)}`;
}

export function isValidCustomerPhone(input, country) {
  const trimmed = String(input || '').trim();
  if (!trimmed) return false;
  let digits = '';
  for (let index = 0; index < trimmed.length; index += 1) {
    const character = trimmed[index];
    if (character >= '0' && character <= '9') {
      digits += character;
    } else if (!(/\s/.test(character) || '-()'.includes(character) || (character === '+' && index === 0))) {
      return false;
    }
  }
  if (country === 'MY') {
    if (digits.startsWith('60')) digits = digits.slice(2);
    if (digits.startsWith('0')) digits = digits.slice(1);
    return (digits.length === 9 || digits.length === 10) && digits.startsWith('1');
  }
  if (digits.startsWith('65') && digits.length === 10) digits = digits.slice(2);
  return digits.length === 8 && '689'.includes(digits[0]);
}

export function expiryFor(claimedAt, validityDays) {
  const claimed = new Date(claimedAt);
  const singaporeParts = new Intl.DateTimeFormat('en-CA', {
    timeZone: SINGAPORE_TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(claimed).reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
  const date = new Date(`${singaporeParts.year}-${singaporeParts.month}-${singaporeParts.day}T15:59:59.999Z`);
  date.setUTCDate(date.getUTCDate() + Number(validityDays));
  return date.toISOString();
}

export function voucherStatus(claim, now = new Date()) {
  if (claim.redeemed_at) return 'redeemed';
  if (new Date(claim.expires_at) < now) return 'expired';
  return 'active';
}

export function redemptionError(claim, merchantBusinessId, now = new Date()) {
  if (!claim || claim.business_id !== merchantBusinessId) return 'Voucher not found for your business.';
  if (claim.redeemed_at) return 'This voucher has already been redeemed.';
  if (new Date(claim.expires_at) < now) return 'This voucher has expired.';
  return null;
}

export function campaignSnapshot(campaign) {
  return {
    voucher_title_snapshot: campaign.title,
    discount_type_snapshot: campaign.discount_type,
    discount_value_snapshot: campaign.discount_value,
    minimum_spend_snapshot: campaign.minimum_spend,
    terms_snapshot: campaign.terms,
  };
}

export function formatDate(value) {
  return new Intl.DateTimeFormat('en-SG', {
    timeZone: SINGAPORE_TIME_ZONE,
    day: 'numeric', month: 'long', year: 'numeric',
  }).format(new Date(value));
}

export function money(value) {
  const formatted = new Intl.NumberFormat('en-SG', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(value);
  return `S$${formatted}`;
}

export function validateBusiness(input) {
  const errors = {};
  if (!input.name?.trim()) errors.name = 'Enter your business name.';
  if (input.whatsapp_number && !/^\+?[0-9 ]{8,16}$/.test(input.whatsapp_number)) errors.whatsapp_number = 'Enter a valid phone number.';
  if (input.primary_action_url && !/^https?:\/\//i.test(input.primary_action_url)) errors.primary_action_url = 'Use a full URL beginning with http:// or https://.';
  return errors;
}

export function validateCampaign(input) {
  const errors = {};
  if (!input.title?.trim()) errors.title = 'Enter a voucher title.';
  if (!['fixed', 'percentage'].includes(input.discount_type)) errors.discount_type = 'Choose a discount type.';
  if (!(Number(input.discount_value) > 0)) errors.discount_value = 'Enter a discount greater than zero.';
  if (input.discount_type === 'percentage' && Number(input.discount_value) > 100) errors.discount_value = 'Percentage cannot exceed 100%.';
  if (![14, 30, 45, 60].includes(Number(input.validity_days))) errors.validity_days = 'Choose a validity period.';
  if (input.minimum_spend && Number(input.minimum_spend) < 0) errors.minimum_spend = 'Minimum spend cannot be negative.';
  return errors;
}
